export const escapeHtml = (value = '') => value.toString()
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;');

export const getOnboardingStatusClass = (status = '') => {
    switch (status.toString().trim().toLowerCase()) {
        case 'draft':
            return 'activeStatus userRequestStatusDraft';
        case 'submitted':
            return 'activeStatus userRequestStatusSubmitted';
        case 'under review':
            return 'activeStatus userRequestStatusUnderReview';
        case 'approved':
            return 'activeStatus userRequestStatusApproved';
        case 'active':
            return 'activeStatus userRequestStatusActive';
        case 'email verification pending':
            return 'activeStatus userRequestStatusEmailPending';
        case 'email verified':
            return 'activeStatus userRequestStatusEmailVerified';
        default:
            return '';
    }
};

export const renderOnboardingStatus = (status = '') => {
    const displayStatus = status?.toString().trim() || '';
    const statusClass = getOnboardingStatusClass(displayStatus);
    if (!displayStatus) return '';
    if (!statusClass) return escapeHtml(displayStatus);
    return `<span class="statusTd"><span class="${statusClass}">${escapeHtml(displayStatus)}</span></span>`;
};

// Approved onboarding users are no longer editable via the super-admin edit endpoint.
export const isOnboardingEditable = (status) => {
    if (status === null || status === undefined) return true;
    return status.toString().trim().toLowerCase() !== 'approved';
};

export const mapUserRequestRow = (item, index) => ({
    ...item,
    listIndex: index,
    isChecked: false,
    statusHtml: renderOnboardingStatus(item.OnboardingStatus),
    isEditable: isOnboardingEditable(item.OnboardingStatus),
});
